import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

/** Fluent UI `Modal` uses `ZIndexes.Layer` (1_000_000); tooltips must sit above it. */
const TOOLTIP_Z_ABOVE_FLUENT_MODAL = 1_000_002;

/**
 * Single-line text with ellipsis; hover shows full string in a tooltip.
 */
export function TruncatedTextWithTooltip({ text, placement = "top", sx, ...boxProps }) {
  const full = text == null ? "" : String(text);
  if (full === "") {
    return (
      <Box component="span" sx={sx} {...boxProps}>
        —
      </Box>
    );
  }
  return (
    <Tooltip
      title={full}
      placement={placement}
      arrow
      slotProps={{
        popper: {
          sx: { zIndex: TOOLTIP_Z_ABOVE_FLUENT_MODAL },
        },
        tooltip: {
          sx: {
            maxWidth: 480,
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
        },
      }}
    >
      <Box
        component="span"
        {...boxProps}
        sx={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
          minWidth: 0,
          cursor: "default",
          ...sx,
        }}
      >
        {full}
      </Box>
    </Tooltip>
  );
}
